<template>
  <section class="slide sec2 kenBurns overflow-hidden opacity-0 fixed w-full h-full" name="linens">
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap table-cell align-middle text-center">
          <div class="fix-width max-w-734px ml-auto mr-auto text-left">
            <p
              class="cropBottom courier left ae-2 fromCenter text-lg font-anonymouse font-medium leading-lh3 text-white opacity-80"
            >{{desc}}</p>
          </div>
        </div>
      </div>
    </div>

    <NextButton title="Linens" />

    <div
      class="background absolute top-0 left-0 w-full h-full bg-center bg-cover bg-no-repeat"
      :style="{backgroundImage: 'url('+bgImg+')'}"></div>
  </section>
</template>

<script>
import NextButton from "../common/NextButton";

export default {
  name: "Section4",
  props: ["desc", "bgImg"],
  components: {
    NextButton
  }
};
</script>

<style scoped>
</style>